import { isSetNewsletterDisplayedCookie, isSetRegionalDisplayedCookie } from '../../helpers/cookie';
import NewsletterLightbox from '../Lightboxes/NewsletterLightbox';
import RegionalLightbox from '../Lightboxes/RegionalLightbox';
import { ModalProps, ModalAutoDisplayerProps } from './interfaces';
import Country from '../../common/models/Country';

const scrollEvent = 'scroll';
const visitEvent = 'visit';

const modalNames = {
  newsletter: 'newsletter',
  regional: 'regional',
};

const newsletterModalConfig = {
  allowedCountries: Country.regionalPopupCountries(),
  checkIfCookieSet: isSetNewsletterDisplayedCookie,
  checkIfShouldBeDisplayed: ({ newsletterModalVisible }: ModalAutoDisplayerProps) => newsletterModalVisible,
  close: ({ setNewsletterVisibility }: ModalAutoDisplayerProps) => {
    setNewsletterVisibility(false);
  },
  component: NewsletterLightbox,
  display: ({ setNewsletterVisibility }: ModalAutoDisplayerProps) => {
    setNewsletterVisibility(true);
  },
  event: scrollEvent,
  maxOncePerPageView: true,
  scrollPercentage: 80.0,
};

const regionalModalConfig = {
  allowedCountries: Country.regionalPopupCountries(),
  checkIfCookieSet: isSetRegionalDisplayedCookie,
  checkIfShouldBeDisplayed: ({ regionalModalVisible }: ModalAutoDisplayerProps) => regionalModalVisible,
  close: ({ setRegionalVisibility }: ModalAutoDisplayerProps) => {
    setRegionalVisibility(false);
  },
  component: RegionalLightbox,
  display: ({ setRegionalVisibility }: ModalAutoDisplayerProps) => {
    setRegionalVisibility(true);
  },
  event: visitEvent,
  maxOncePerPageView: true,
  scrollPercentage: undefined,
};

const modals: { [name: string]: ModalProps } = {
  [modalNames.newsletter]: newsletterModalConfig,
  [modalNames.regional]: regionalModalConfig,
};

export { modals, modalNames, scrollEvent, visitEvent };
